import "./pManagement/pManagement.sass";

import { pManagementDirective } from './pManagement/pManagement.directive';
import { ManagementService } from './Management.service';

export default angular.module('frontend.management', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pManagement', pManagementDirective)
  .service('Management', ManagementService);
